/**
 * Toolbar for a Tool (SMSWiser) table: group-by select + text filter.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Layers, Search } from 'lucide-react';

import { Input } from '@/components/ui';

import type { ToolGroupOption } from '../shared/tool-grouping';

interface ToolStatsToolbarProps {
  groupOptions: ToolGroupOption[];
  groupBy: string;
  onGroupByChange: (value: string) => void;
  search: string;
  onSearchChange: (value: string) => void;
  rowCount: number;
}

export const ToolStatsToolbar: FC<ToolStatsToolbarProps> = ({
  groupOptions,
  groupBy,
  onGroupByChange,
  search,
  onSearchChange,
  rowCount,
}) => (
  <div className="flex flex-wrap items-center gap-2">
    {groupOptions.length > 1 && (
      <label className="inline-flex items-center gap-1.5 text-sm">
        <Layers className="h-4 w-4 text-muted-foreground" />
        <span className="text-muted-foreground">Group by</span>
        <select
          value={groupBy}
          onChange={(e) => onGroupByChange(e.target.value)}
          className="rounded-md border border-border bg-background px-2 py-1 text-sm"
        >
          {groupOptions.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>
    )}
    <div className="relative">
      <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Filter rows…"
        className="h-8 w-48 pl-8 text-sm"
      />
    </div>
    <span className="text-xs text-muted-foreground">{rowCount} rows</span>
  </div>
);

export default ToolStatsToolbar;
